import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, onSnapshot, query } from 'firebase/firestore'; 

// --- Formatlama Fonksiyonları ---
function formatCurrency(number) {
    if (typeof number !== 'number') return '---';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
}
// ---------------------------------

function Odemeler() {
  
  const [odemeler, setOdemeler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate(); 

  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // --- Veri Çekme (Tüm Ödemeler) ---
  useEffect(() => {
    const q = query(collection(db, 'odemeler'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const odemelerList = [];
      querySnapshot.forEach((doc) => {
        odemelerList.push({ id: doc.id, ...doc.data() });
      });
      setOdemeler(odemelerList);
      setLoading(false);
    }, (err) => {
      setError("Ödemeler çekilemedi.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, []); 
  
  // --- Ödemeleri Tedarikçiye Göre Gruplama ---
  const tedarikciGruplari = useMemo(() => {
    const groups = {};
    const bugun = new Date(); 
    
    odemeler.forEach(odeme => {
        const cariId = odeme.cariId;
        // Tarih verisini güvenli hale getir
        const odemeTarihi = odeme.odemeTarihi?.toDate ? odeme.odemeTarihi.toDate() : new Date(odeme.odemeTarihi);
        
        // Oluşturulma zamanı (Yeni ekleneni tespit etmek için)
        // Eğer createdAt yoksa (eski kayıt) veya null ise şimdiki zamanı varsayalım (listede üstte kalsın diye)
        const eklenmeZamani = odeme.createdAt?.toDate ? odeme.createdAt.toDate() : new Date(0);

        if (!groups[cariId]) {
            groups[cariId] = { 
                cariId: cariId,
                firmaSahis: odeme.firmaSahis,
                toplamBorc: 0,
                kalanBorc: 0,
                bekleyenOdemeler: 0,
                vadesiGecenMiktar: 0,
                sonIslemZamani: eklenmeZamani // İlk değer
            };
        }
        
        // Bu grubun son işlem zamanını güncelle (Eğer bu ödeme daha yeniyse)
        if (eklenmeZamani > groups[cariId].sonIslemZamani) {
            groups[cariId].sonIslemZamani = eklenmeZamani;
        }

        groups[cariId].toplamBorc += odeme.miktar;
        
        if (odeme.durum === 'Bekliyor') {
            groups[cariId].kalanBorc += odeme.miktar;
            groups[cariId].bekleyenOdemeler++;
            
            if (odemeTarihi < bugun) {
                groups[cariId].vadesiGecenMiktar += odeme.miktar;
            }
        }
    });
    
    // SIRALAMA DEĞİŞİKLİĞİ:
    // Eskiden: Borca göre sıralıyordu (b.kalanBorc - a.kalanBorc)
    // Şimdi: Son işlem zamanına göre sıralıyor (En son eklenen en üstte)
    return Object.values(groups).sort((a, b) => b.sonIslemZamani - a.sonIslemZamani); 
  }, [odemeler]);
  
  const handleRowClick = (cariId) => {
      navigate(`/tedarikciler/${cariId}`); 
  }

  return (
    <div className="admin-page">
      
      {/* --- MODERN HEADER --- */}
      <div className="admin-header">
        <h1 
            className="brand-logo admin-brand-header"
            onClick={() => navigate('/admin/dashboard')}
            style={{ cursor: 'pointer', flex: 1 }}
            title="Admin Paneline Dön"
        >
           <img src="/logo.png" width="50" alt="" />
           ARAS ASAF İNŞAAT – GİDER/BORÇ LİSTESİ
        </h1>

        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div className="date-time-info" style={{marginRight: '10px'}}>
              {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
            </div>

            <button 
                onClick={() => navigate('/yeni-odeme')} 
                className="admin-button"
                style={{ fontSize: '0.9rem' }}
            >
                + Yeni Ödeme Ekle
            </button>

            <button 
                onClick={() => navigate('/admin/dashboard')} 
                className="admin-button-secondary small"
            >
                ← Geri
            </button>
        </div>
      </div>

      <div className="admin-table-container">
        <h2 style={{ color: '#D4AF37' }}>TEDARİKÇİ BAZLI HAREKETLER ({tedarikciGruplari.length})</h2>
        <p style={{fontSize: '0.9rem', color: '#666', marginBottom: '10px'}}>* Liste son işlem tarihine göre sıralanmıştır (En yeni en üstte).</p>
        
        {loading && <p className="loading-text">Veriler yükleniyor...</p>}
        {error && <p className="login-error">{error}</p>}
        
        {!loading && !error && (
            <table className="admin-table">
            <thead>
                <tr>
                <th>FİRMA/ŞAHIS</th>
                <th>Toplam İşlem</th>
                <th>Kalan Borç</th>
                <th>Vadesi Geçen</th>
                <th>Bekleyen</th>
                <th>Aksiyon</th>
                </tr>
            </thead>
            <tbody>
                {tedarikciGruplari.map((grup) => (
                <tr key={grup.cariId} className="table-row-clickable" onClick={() => handleRowClick(grup.cariId)}>
                    <td>{grup.firmaSahis}</td>
                    <td>{formatCurrency(grup.toplamBorc)}</td>
                    <td>
                        <span className={grup.kalanBorc > 0 ? 'status-pending' : 'status-paid'}>
                            {formatCurrency(grup.kalanBorc)}
                        </span>
                    </td>
                    <td>
                        <span className={grup.vadesiGecenMiktar > 0 ? 'status-overdue' : 'status-paid'}>
                            {formatCurrency(grup.vadesiGecenMiktar)}
                        </span>
                    </td>
                    <td>{grup.bekleyenOdemeler} Adet</td>
                    <td>
                        <button onClick={(e) => { e.stopPropagation(); handleRowClick(grup.cariId); }} className="admin-button-secondary small">
                            Detay &rarr;
                        </button>
                    </td>
                </tr>
                ))}
                
                {tedarikciGruplari.length === 0 && (
                <tr>
                    <td colSpan="6" style={{ textAlign: 'center' }}>Sistemde kayıtlı gider (ödeme) bulunmamaktadır.</td>
                </tr>
                )}
            </tbody>
            </table>
        )}
      </div>
    </div>
  );
}

export default Odemeler;